import React, { useContext } from "react";
import { DownloadLink, useTranslator } from "@sia/style-guide";
import GlobalContext from "contexts/GlobalContext";

/**
 * Component that renders a link to the IDP login page.
 *
 * @returns {JSX.Element} The LinkToLogin component.
 */
const LinkToLogin = () => {
  const translate = useTranslator();
  const { loginUrl } = useContext(GlobalContext);

  return (
    /* @ts-ignore */
    <DownloadLink
      openInCurrentTab
      icon="INTERNAL"
      variant="EXTERNAL"
      href={loginUrl}
      text={translate("benchmarking.go-to-log-in.text")}
    ></DownloadLink>
  );
};

export default LinkToLogin;
